<ng-container *ngIf="gifts.length">
  <section class="row mb-2">
    <div class="col-12 d-flex align-items-top justify-content-start">
      <div>
        <i-feather name="gift"
                   class="icon-gift text-primary me-3"></i-feather>
      </div>
      <div>
        <h2 class="h4 fw-bolder"
            [translate]="'BOOKING-PART.COMPLETED-ITEMS-INFO.GIFT-INFO.TITLE'"></h2>
        <p class="subtitle pre-wrap m-0"
           [translate]="'BOOKING-PART.COMPLETED-ITEMS-INFO.GIFT-INFO.DESCRIPTION'"></p>
        <span class="scroll-link d-flex mb-2"
                type='button'
                (click)="scrollToGiftsList()">
          <span [translate]="'BOOKING-PART.COMPLETED-ITEMS-INFO.GIFT-INFO.SCROLL-LINK'"></span>
          <i-feather name="chevron-right"></i-feather>
        </span>
      </div>
    </div>
  </section>
</ng-container>
